import React from 'react';
const testimonials = [{
  name: 'Martín Rodríguez',
  role: 'Coach M14 — Club Pucará',
  country: '🇦🇷 Argentina',
  initials: 'MR',
  color: 'from-blue-500 to-blue-700',
  text: 'En tres meses noté un cambio total en la organización de los entrenamientos. Los drills están pensados para cada categoría y los chicos progresan mucho más rápido. Vale cada centavo.',
  rating: 5
}, {
  name: 'Diego Fernández',
  role: 'Entrenador Plantel Superior',
  country: '🇺🇾 Uruguay',
  initials: 'DF',
  color: 'from-emerald-500 to-emerald-700',
  text: 'El Sistema 360 me ordenó la planificación anual completa. Llegué a las prácticas con un plan claro y los jugadores lo notaron desde el primer día. Excelente material.',
  rating: 5
}, {
  name: 'Javier Morales',
  role: 'Coach M16 — Old Reds',
  country: '🇨🇱 Chile',
  initials: 'JM',
  color: 'from-purple-500 to-purple-700',
  text: 'Las fichas técnicas y los registros de evaluación me cambiaron la forma de medir el progreso. Por fin tengo datos reales para hablar con los jugadores y los padres.',
  rating: 5
}, {
  name: 'Carlos Iglesias',
  role: 'Director Deportivo',
  country: '🇪🇸 España',
  initials: 'CI',
  color: 'from-rose-500 to-rose-700',
  text: 'Buscaba un sistema serio y profesional. Esto va mucho más allá de lo que esperaba: drills, gestión, preparación física, todo integrado. Lo recomiendo a todos los coaches del club.',
  rating: 5
}, {
  name: 'Andrés Vargas',
  role: 'Coach Infantiles M8-M12',
  country: '🇲🇽 México',
  initials: 'AV',
  color: 'from-amber-500 to-amber-700',
  text: 'Los bonos de gestión me ayudaron a comunicarme mejor con los padres y a estructurar el club. Es como tener un mentor a mano cuando lo necesito.',
  rating: 5
}, {
  name: 'Felipe Castaño',
  role: 'Entrenador M18',
  country: '🇨🇴 Colombia',
  initials: 'FC',
  color: 'from-cyan-500 to-cyan-700',
  text: 'Soy coach hace 8 años y nunca había visto un material tan completo en español. Los drills son aplicables desde el primer entrenamiento. Inversión 100% recomendada.',
  rating: 5
}];
export function TestimonialsSection() {
  return <section className="w-full bg-bg-main py-14 sm:py-24 px-4 sm:px-6 relative overflow-hidden" data-id="element-411">
      {/* Background accents */}
      <div className="absolute top-0 left-1/4 w-[500px] h-[500px] bg-primary/5 rounded-full blur-[120px] pointer-events-none" aria-hidden="true" data-id="element-412"></div>
      <div className="absolute bottom-0 right-1/4 w-[500px] h-[500px] bg-cta-green/5 rounded-full blur-[120px] pointer-events-none" aria-hidden="true" data-id="element-413"></div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-414">
        <div className="text-center mb-10 sm:mb-16" data-id="element-415">
          <span className="inline-block text-primary font-bold text-xs sm:text-sm tracking-widest uppercase mb-3 bg-primary/10 px-4 py-1.5 rounded-full border border-primary/20" data-id="element-416">
            🌎 Coaches de toda Latinoamérica y España
          </span>
          <h2 className="text-3xl sm:text-5xl font-black text-text-main tracking-tight" data-id="element-417">
            Lo que dicen los entrenadores
          </h2>
          <p className="text-text-sec text-base sm:text-lg mt-4 max-w-2xl mx-auto" data-id="element-418">
            Más de <span className="text-primary font-bold" data-id="element-419">2.000 coaches</span>{' '}
            ya están usando el Sistema 360 en sus clubes
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6" data-id="element-420">
          {testimonials.map((t, i) => <article key={i} className="bg-bg-alt border border-border-light rounded-2xl p-6 sm:p-7 hover:border-primary/40 hover:shadow-[0_0_30px_rgba(59,130,246,0.1)] transition-all duration-300 flex flex-col" data-id="element-421">
              {/* Stars */}
              <div className="flex items-center gap-1 mb-4" aria-label={`${t.rating} de 5 estrellas`} data-id="element-422">
                {Array.from({
              length: t.rating
            }).map((_, idx) => <span key={idx} className="text-secondary text-lg" data-id="element-423">
                    ★
                  </span>)}
              </div>

              {/* Quote */}
              <p className="text-text-main text-[15px] sm:text-base leading-relaxed mb-6 flex-grow" data-id="element-424">
                "{t.text}"
              </p>

              {/* Author */}
              <div className="flex items-center gap-3 pt-4 border-t border-border-light" data-id="element-425">
                <div className={`w-12 h-12 rounded-full bg-gradient-to-br ${t.color} flex items-center justify-center text-white font-black text-base flex-shrink-0 shadow-lg`} aria-hidden="true" data-id="element-426">
                  {t.initials}
                </div>
                <div className="min-w-0" data-id="element-427">
                  <p className="text-text-main font-bold text-sm truncate" data-id="element-428">
                    {t.name}
                  </p>
                  <p className="text-text-sec text-xs truncate" data-id="element-429">{t.role}</p>
                  <p className="text-text-sec text-xs mt-0.5" data-id="element-430">{t.country}</p>
                </div>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}